<div class="event-row-block">
  <div class="event-row" (click)="onRowClick()">
    <img
      appImageZoom
      class="event-row-thumb"
      [src]="thumbSrc"
      [alt]="'events.cover-alt' | translate: { name: event.name }"
      (error)="onImageError()"
      loading="lazy"
    />
    <div class="event-row-body">
      <p class="event-row-name" [class.event-row-name--plain]="plainName"
        [class.event-row-name--wrap]="wrapName">{{ event.name }}</p>
      @if (!hideDate) {
      <span class="event-row-date" [class.event-row-date--caption]="caption">
        {{ event.initial_date | dateFormat: "ddd DD \\d\\e MMM YYYY" }}
        @if (caption) { · {{ caption }} }
      </span>
      }
    </div>
    <ng-content select="[rowEnd]" />
    @if (!hideAction && (alwaysShowAction || event.has_direct_sale_products)) {
    <button type="button" class="tap-hint" [class.tap-hint--tall]="alwaysShowAction" (click)="onSellClick($event)">
      <ion-icon [name]="actionIcon" class="hint-icon" aria-hidden="true"></ion-icon>
      {{ actionLabelKey | translate }}
    </button>
    }
  </div>
</div>
